import { CheckCircleIcon, XIcon } from "@heroicons/react/outline";

export type TextAlertProps = {
  isDismissable: boolean;
  info: string;
  severity: "info" | "warning" | "danger" | "success";
  onClose: () => void;
};

export const TextAlert = (props: TextAlertProps) => {
  const alertColor = getTextAlertColor(props.severity);

  return (
    <div className={`rounded-md bg-${alertColor}-50 p-4`}>
      <div className="flex">
        <div className="flex-shrink-0">
          <CheckCircleIcon
            className={`h-5 w-5 text-${alertColor}-400`}
            aria-hidden="true"
          />
        </div>
        <div className="ml-3">
          <p className={`text-sm font-medium text-${alertColor}-800`}>
            {props.info}
          </p>
        </div>
        {props.isDismissable && (
          <div className="ml-auto pl-3">
            <div className="-mx-1.5 -my-1.5">
              <button
                onClick={() => props.onClose()}
                type="button"
                className={`inline-flex bg-${alertColor}-50 rounded-md p-1.5 text-${alertColor}-500 hover:bg-${alertColor}-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-${alertColor}-50 focus:ring-${alertColor}-600`}
              >
                <span className="sr-only">Dismiss</span>
                <XIcon className="h-5 w-5" aria-hidden="true" />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const getTextAlertColor = (severity: string) => {
  switch (severity) {
    case "info":
      return "blue";
    case "warning":
      return "yellow";
    case "danger":
      return "red";
    case "success":
      return "green";
    default:
      return "blue";
  }
};
